import { firebaseMutations, firebaseAction } from 'vuexfire'
import firebaseApp from './../firebase-setup'
import * as getterConstants from './getterConstants'
import { limitedFilter, limitedBrowsingFilter } from './filters'
const db = firebaseApp.database()

const objectivesRef = db.ref('objectives')
const draftsObjectivesRef = db.ref('drafts/objectives')
const currentObjectivesRef = (currentUserId) => { return db.ref('objectives/' + currentUserId) }
const currentDraftsObjectivesRef = (currentUserId) => { return db.ref('drafts/objectives/' + currentUserId) }
export const objectivesModule = {
  namespaced: true,
  state: {
    objectives: {},
    draftsObjectives: {},
    currentObjectives: {},
    currentObjectiveId: {},
    currentDraftsObjectives: {}
  },
  mutations: {
    ...firebaseMutations
  },
  actions: {
    [getterConstants.GET_OBJECTIVES]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_OBJECTIVES')
      bindFirebaseRef('objectives', objectivesRef, { wait: true })
    }),
    [getterConstants.GET_DRAFTS_OBJECTIVES]: firebaseAction(({ bindFirebaseRef }) => {
      // console.log('bind:getterConstants.GET_DRAFTS_OBJECTIVES')
      bindFirebaseRef('draftsObjectives', draftsObjectivesRef, { wait: true })
    }),
    [getterConstants.GET_CURRENT_OBJECTIVES]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_OBJECTIVES', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentObjectives', currentObjectivesRef(currentUserId), { wait: true })
    }),
    [getterConstants.GET_CURRENT_DRAFTS_OBJECTIVES]: firebaseAction(({ bindFirebaseRef }, currentUserId) => {
      // console.log('bind:getterConstants.GET_CURRENT_DRAFTS_OBJECTIVES', currentUserId)
      if (!currentUserId) currentUserId = '__GHOST_USER__'
      bindFirebaseRef('currentDraftsObjectives', currentDraftsObjectivesRef(currentUserId), { wait: true })
    }),
    [getterConstants.SET_NEW_OBJECTIVE]: firebaseAction(async function (context, value) {
      console.log('objective updated!!!!!!!!!!!!!')
      const currentUserId = context.rootState.currentUserId
      if (!value.objectiveId) {
        const newObjectiveRef = objectivesRef.child(currentUserId).push()
        newObjectiveRef.set(value.objectiveInfo)
        for (let i in value.relationInfo) {
          console.log(value.relationInfo)
          const newRelationRef = db
            .ref(
              'objectives/' +
                currentUserId +
                '/' +
                newObjectiveRef.key +
                '/relations'
            )
            .push()
          value.relationInfo[i].dir = 'dst'
          console.log(value.relationInfo[i].dir)
          newRelationRef.set(value.relationInfo[i]).catch(function (error) {
            console.log('error-new-objective-relation', error.message)
          })
        }
      } else {
        const editObjectiveRef = await db
          .ref('objectives/' + currentUserId + '/')
          .child(value.objectiveId)
        editObjectiveRef.update(value.objectiveInfo)
        for (let i in value.relationInfo) {
          value.relationInfo[i].dir = 'dst'
          const newRelationRef = await db
            .ref(
              'objectives/' +
                currentUserId +
                '/' +
                value.objectiveId +
                '/relations'
            )
            .push()
          await newRelationRef.set(value.relationInfo[i]).catch(function (error) {
            console.log('error-edit-objective-relation', error.message)
          })
        }
      }
    }),
    [getterConstants.SET_DRAFTS_OBJECTIVES]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      draftsObjectivesRef.child(currentUserId).remove()
      const newDraftsObjectiveRef = draftsObjectivesRef.child(currentUserId).push()
      newDraftsObjectiveRef.set(value.objectiveInfo)
      for (const i in value.relationInfo) {
        const newDraftsRelationRef = db.ref('drafts/objectives/' + currentUserId + '/' + newDraftsObjectiveRef.key + '/relations').push()
        newDraftsRelationRef.set(value.relationInfo[i])
      }
    }),
    [getterConstants.REMOVE_OBJECTIVE]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const removeObjectiveRef = objectivesRef
        .child(currentUserId)
        .child(value)
      removeObjectiveRef.remove()
    }),
    [getterConstants.SET_OBJECTIVE_COMPLETENESS]: firebaseAction((context, value) => {
      const currentUserId = context.rootState.currentUserId
      const setObjectiveRef = objectivesRef
        .child(currentUserId)
        .child(value.id)
        .child('isComplete')
      setObjectiveRef.set(value.isComplete)
    }),
    [getterConstants.REMOVE_DRAFTS_OBJECTIVES]: firebaseAction((contest, value) => {
      const removeDraftsObjectives = db.ref('drafts/objectives/' + value)
      removeDraftsObjectives.remove()
    })
  },
  getters: {
    getObjectives: state => state.objectives,
    getDraftObjectivess: state => state.draftsObjectivesrs,
    getCurrentObjectives: state => state.currentObjectives,
    getCurrentDraftObjectives: state => state.currentDraftsObjectives,
    getObjectiveById: (state, getters, rootState) => (objectiveId, userId, isAdmin, isForceBrowsing) => {
      let objectives = null
      if (isAdmin || isForceBrowsing) {
        objectives = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.objectives)[userId]
      } else {
        objectives = limitedFilter(rootState.currentUserId, rootState.currentUser, state.objectives)[userId]
      }
      return (objectives || {})[objectiveId] || {}
    },
    getObjectivesByUserId: (state, getters, rootState) => (userId, isAdmin, isForceBrowsing) => {
      let stateObjectives = null
      if (!!isAdmin || !!isForceBrowsing) {
        stateObjectives = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.objectives)
      } else {
        stateObjectives = limitedFilter(rootState.currentUserId, rootState.currentUser, state.objectives)
      }
      return stateObjectives[userId] ? stateObjectives[userId] : {}
    },
    // getObjectivesForPublic: (state, getters, rootState) => userId => {
    //   const objectives = state.objectives[userId]
    //   // let okrForShow = []
    //   console.log('objectives', objectives)
    //   for (const objkey in objectives) {
    //     if (objectives[objkey].limitedAccess) {
    //       console.log(objectives[objkey])
    //     } else {
    //       console.log('hogehoge')
    //     }
    //   }
    // },
    getObjectivesByIds: (state, getters, rootState) => (objectiveIdUserIds, isAdmin, isForceBrowsing) => {
      let objectives = {}
      const rootStateKeyresults = rootState.keyResults.keyresults
      let stateObjectives = null
      let stateKeyresults = null
      if (!!isAdmin || !!isForceBrowsing) {
        stateObjectives = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, state.objectives)
        stateKeyresults = limitedBrowsingFilter(rootState.currentUserId, rootState.currentUser, rootStateKeyresults)
      } else {
        stateObjectives = limitedFilter(rootState.currentUserId, rootState.currentUser, state.objectives)
        stateKeyresults = limitedFilter(rootState.currentUserId, rootState.currentUser, rootStateKeyresults)
      }
      for (let objectiveIdUserId of objectiveIdUserIds) {
        if (objectiveIdUserId.type === 'objectives') {
          objectives[objectiveIdUserId['targetId']] =
            stateObjectives[objectiveIdUserId['userId']][objectiveIdUserId['targetId']]
          objectives[objectiveIdUserId['targetId']].targetType = 'objectives'// targetType情報を追加して返しています
          objectives[objectiveIdUserId['targetId']].userId = objectiveIdUserId['userId']
        } else if (objectiveIdUserId.type === 'keyresults') {
          objectives[objectiveIdUserId['targetId']] =
            stateKeyresults[objectiveIdUserId['userId']][objectiveIdUserId['targetId']]
          objectives[objectiveIdUserId['targetId']].targetType = 'keyresults'// targetType情報を追加して返しています
          objectives[objectiveIdUserId['targetId']].userId = objectiveIdUserId['userId']
        }
      }
      return objectives
    },
    getOkrsByText: (state, getters, rootState) => text => {
      let okrs = []
      const regexp = new RegExp(text, 'i')
      const stateObjectives = state.objectives
      const stateKeyresults = rootState.keyResults.keyresults
      for (const key in stateObjectives) {
        if (!stateObjectives[key].contentText) {
          continue
        }
        if (stateObjectives[key].contentText.match(regexp)) {
          okrs.push({
            key: key,
            okr: stateObjectives[key],
            type: 'objectives'
          })
        }
      }
      for (const key in stateKeyresults) {
        if (!stateKeyresults[key].contentText) {
          continue
        }
        if (stateKeyresults[key].contentText.match(regexp)) {
          okrs.push({
            key: key,
            okr: stateKeyresults[key],
            type: 'keyresults'
          })
        }
      }
      return okrs
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/objectives.js